import { Component } from '@angular/core';

@Component({
  selector: 'app-about-us',
  standalone: true,
  imports: [],
  templateUrl: './about-us.component.html',
  styleUrl: './about-us.component.scss'
})
export class AboutUsComponent {



  scrollingtoTop(){
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
